import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class PotteryGardenGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PotteryGardenGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "potterygardenGallery",
      'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ PotteryGardenGallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/pottery-garden')
  }


  render() {
    return (
      <>
      <div className="container-fluid text-left">
        <h1 className="text-uppercase">Pottery &amp; Garden Supplies GALLERY</h1>
      </div>
      
      <div>
        {this.state.PotteryGardenGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.PotteryGardenGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-4 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.potteryGardenGalleryPhoto.fields.file.url} alt="sam bridge pottery garden supplies photos" /></label>
                              <label htmlFor={num}><img src={item.fields.potteryGardenGalleryPhoto.fields.file.url} alt="sam bridge pottery garden supplies photos" /></label>
                              {/* <p className="text-center">{item.fields.potteryGardenGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Pottery &amp; Garden Supplies</button></Link></p>
      </div>
    </>
    );
  }
}

export default PotteryGardenGallery;
